import type * as React from "react";
interface RadioOption {
  value: string;
  title: string;
  description: string;
  icon?: string;
}

interface RadioOptionGridProps {
  options: RadioOption[];
  selectedValue?: string;
  onSelectionChange: (value: string) => void;
}

const RadioOptionGrid: React.FC<RadioOptionGridProps> = ({
  options,
  selectedValue,
  onSelectionChange
}) => {
  const handleCardClick = (value: string) => {
    onSelectionChange(value);
  };

  const isSelected = (value: string): boolean => {
    return selectedValue === value;
  };

  return (
    <div className="gl-radio-option-grid">
      <div className="gl-radio-option-grid-container">
        {options.map((option) => (
          <div
            key={option.value}
            className={`gl-radio-option-card ${
              isSelected(option.value) ? "gl-radio-option-card--selected" : ""
            }`}
            onClick={() => handleCardClick(option.value)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleCardClick(option.value);
              }
            }}
            aria-pressed={isSelected(option.value)}
            aria-label={`Select ${option.title} option`}
          >
            <div className="gl-radio-option-card-content">
              {option.icon && (
                <div className="gl-radio-option-icon">
                  <img
                    src={option.icon}
                    alt={`${option.title} icon`}
                    width={40}
                    height={40}
                    aria-hidden="true"
                  />
                </div>
              )}
              <h3 className="gl-radio-option-title">{option.title}</h3>
              <p className="gl-radio-option-description">
                {option.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RadioOptionGrid;
